export default __webpack_public_path__ + "static/media/pal.5efb8c3b.png";